import { VF_SINGLE_RADIO } from 'AppSrc/core/components/forms/form-base-components/v-f-single-radio';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { STATUS_REASON } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import { PostChangeCommsLabel } from 'AppSrc/core/components/forms/form-types/completion-review/section-three/post-change-comms-label';

const fieldId = STATUS_REASON;
const initialValues = null;
const summaryDisplayOptions = {
  fixed: [
    {
      label: PostChangeCommsLabel,
      text: 'Completed - Successful',
      value: '5000',
    }, {
      label: PostChangeCommsLabel,
      text: 'Completed - Unsuccessful',
      value: '6200',
    },
  ],
  mobile: [
    {
      label: PostChangeCommsLabel,
      text: 'Completed - Successful',
      value: 'Successful',
    }, {
      label: PostChangeCommsLabel,
      text: 'Completed - Unsuccessful',
      value: 'Unsuccessful',
    },
  ],
};

const vFParams = {
  /* eslint-disable-next-line no-confusing-arrow */
  formatCurrentValue: ({ value }) => value ? value : null,
  summaryDisplayOptions,
  fieldTitle: '',
};



const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_SINGLE_RADIO);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const postChangeCommsSelector = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_SINGLE_RADIO,
};

export { postChangeCommsSelector, summaryDisplayOptions };

